import { render, staticRenderFns } from "./xeIodCard.vue?vue&type=template&id=5633ecbe&scoped=true"
import script from "./xeIodCard.vue?vue&type=script&lang=js"
export * from "./xeIodCard.vue?vue&type=script&lang=js"
import style0 from "./xeIodCard.vue?vue&type=style&index=0&id=5633ecbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5633ecbe",
  null
  
)

export default component.exports